import React, { useState, useEffect, useRef } from "react";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import "./style.scss";
import {
  getRouting,
  digitToRupeeNotation,
} from "../../../../../utils/common";
import { PieChart } from "react-minimal-pie-chart";
import { NumericFormat } from "react-number-format";
import formulajs from "@formulajs/formulajs";

const SipCalculator = (props) => {

  const {
    IAPdata,
  } = props;
  const titledata = IAPdata;
  const [handleAmount, sethandleAmount] = useState(100);
  const [handleRate, sethandleRate] = useState(8);
  const [handlePeriod, sethandlePeriod] = useState(15);
  const [frequency, setfrequency] = useState(0);
  const [totalSIP, settotalSIP] = useState(0);
  const [freqMapping, setfreqMapping] = useState(0);
  const [freqMappingMonth, setfreqMappingMonth] = useState('daily');
  const [totalPiePercent, settotalPiePercent] = useState(0);
  const [amountErr, setamountErr] = useState(false);
  const [rateErr, setrateErr] = useState(false);
  const [timeErr, settimeErr] = useState(false);
  useEffect(() => {
    const totalSipValue = sipCalculator(
      handleAmount,
      frequency,
      handleRate,
      handlePeriod
    );

    settotalSIP(Math.round(totalSipValue));
  }, []);

  const handleChangeAmount = (event) => {
    const totalAmountRegularlyInvest = parseFloat(
      event.target.value.replace(/,/g, "")
    );

    if (totalAmountRegularlyInvest % 100) {
      sethandleAmount(totalAmountRegularlyInvest);
      setamountErr(true);
    } else if (
      totalAmountRegularlyInvest > 10000000 ||
      totalAmountRegularlyInvest < 100
    ) {
      sethandleAmount(totalAmountRegularlyInvest);
      setamountErr(true);
    } else {
      sethandleAmount(totalAmountRegularlyInvest);
      setamountErr(false);
      const totalSipValue = sipCalculator(
        totalAmountRegularlyInvest,
        frequency,
        handleRate,
        handlePeriod
      );
      settotalSIP(Math.round(totalSipValue));
    }
  };

  const handleChangeFreq = (event) => {
    setfrequency(event);
    const totalSipValue = sipCalculator(
      handleAmount,
      event,
      handleRate,
      handlePeriod
    );

    settotalSIP(Math.round(totalSipValue));
  };

  const handleChangeRate = (event) => {
    const re = /^[0-9.\b]+$/;

    // if value is not blank, then test the regex

    if (event.target.value === "" || re.test(event.target.value)) {
      if (event.target.value > 13 || event.target.value < 2) {
        sethandleRate(event.target.value);
        setrateErr(true);
        //const totalSipValue = inflationCalculator(monthAmount, 1, yearExpense);
      } else {
        sethandleRate(event.target.value);
        setrateErr(false);
        const totalSipValue = sipCalculator(
          handleAmount,
          frequency,
          event.target.value,
          handlePeriod
        );

        settotalSIP(Math.round(totalSipValue));
      }
    }
  };

  const handleChangePeriod = (event) => {
    const re = /^[0-9.\b]+$/;

    // if value is not blank, then test the regex

    if (event.target.value === "" || re.test(event.target.value)) {
      if (event.target.value > 50 || event.target.value < 1) {
        sethandlePeriod(event.target.value);
        settimeErr(true);
        //const totalSipValue = inflationCalculator(monthAmount, 1, yearExpense);
      } else {
        sethandlePeriod(event.target.value);
        settimeErr(false);
        const totalSipValue = sipCalculator(
          handleAmount,
          frequency,
          handleRate,
          event.target.value
        );

        settotalSIP(Math.round(totalSipValue));
      }
    }
  };

  function sipCalculator(handleAmount, frequency, handleRate, handlePeriod) {
    let freq = 0;
    if (frequency === 0) {
      freq = 365;
      setfreqMapping(365);
      setfreqMappingMonth('daily');
    }
    if (frequency === 1) {
      freq = 52;
      setfreqMapping(52);
      setfreqMappingMonth('weekly');
    }
    if (frequency === 2) {
      freq = 12;
      setfreqMapping(12);
      setfreqMappingMonth('monthly');
    }
    if (frequency === 3) {
      freq = 4;
      setfreqMapping(4);
      setfreqMappingMonth('quarterly');
    }

    let timePeriod = freq,
      i = freq * (Math.pow(1 + handleRate/100,1/freq) - 1),
      n = handlePeriod * timePeriod,
      returnValue = formulajs.FV(
        i / timePeriod,
        n,
        -handleAmount,
        0,
        1
      );

    const totalPieValue =
      returnValue + handleAmount * freqMapping * handlePeriod;

    settotalPiePercent(Math.round(totalPieValue));

    return returnValue;
  }

  let smallPie = "";
  let bigPie = "";
  if (amountErr === false && rateErr === false && timeErr === false) {
    smallPie =
      ((handleAmount * freqMapping * handlePeriod) / totalPiePercent) * 100;
    bigPie = (totalSIP / totalPiePercent) * 100;
  } else {
    smallPie = 0;
    bigPie = 0;
  }

  return (
      <section className="inflationtoolsdiv">
        <div className="container">
          <div className="row my-5 gx-5">
            <div className="col-md-6">
              <div className="toolsfirstdiv me-md-3">
                <h2 className="mb-3"><span>SIP</span> Calculator</h2>
                {/* <p className="mb-4">
                  If you are earning more you should invest more. find out how
                  much more your wealth can grow by Increasing the amount of
                  your SIP instalments with top up.
                </p> */}
                <div className="mb-4">
                  <div className="align-items-center row mb-3">
                    <div className="col-7 text-break">
                      <h4>Amount I will regularly invest</h4>
                    </div>
                    <div className="col-5 d-flex justify-content-end">
                      <NumericFormat
                        type="text"
                        className="amtwidth"
                        placeholder="₹ 0"
                        value={handleAmount}
                        onChange={handleChangeAmount}
                        thousandSeparator={","}
                        thousandsGroupStyle="lakh"
                        decimalSeparator={"."}
                      />
                    </div>
                    <div className="col-8">&nbsp;</div>
                    {amountErr ? (
                      <div className="col-12 d-flex justify-content-end errortext">
                        <span style={{ color: "red", fontSize: 12 }}>
                          Value should be between 100 - 1,00,00,000 & multiples
                          of 100
                        </span>
                      </div>
                    ) : null}
                  </div>

                  <div>
                    <input
                      type="range"
                      className="w-100"
                      min="100"
                      max="10000000"
                      step="100"
                      value={handleAmount}
                      onChange={handleChangeAmount}
                    />
                    <div className="d-flex justify-content-between startendval">
                      <span>₹ 100</span>
                      <span>₹ 1,00,00,000</span>
                    </div>
                  </div>
                </div>
                <div>
                  <h4 className="mb-3">My SIP investment frequency</h4>
                  <ul className="sipinvest d-flex flex-wrap mb-4">
                    <li
                      className={frequency === 0 ? "active mb-4" : "mb-4"}
                      onClick={() => handleChangeFreq(0)}
                    >
                      Daily
                    </li>
                    <li
                      className={frequency === 1 ? "active mb-4" : "mb-4"}
                      onClick={() => handleChangeFreq(1)}
                    >
                      Weekly
                    </li>
                    <li
                      className={frequency === 2 ? "active mb-4" : "mb-4"}
                      onClick={() => handleChangeFreq(2)}
                    >
                      Monthly
                    </li>
                    <li
                      className={frequency === 3 ? "active mb-4" : "mb-4"}
                      onClick={() => handleChangeFreq(3)}
                    >
                      Quarterly
                    </li>
                  </ul>
                </div>
                <div className="mb-4">
                  <div className="align-items-center row mb-3">
                    <div className="col-7 text-break">
                      <h4>Expected rate of return</h4>
                    </div>
                    <div className="col-5 d-flex justify-content-end">
                      <input
                        type="text"
                        className="amtwidth"
                        placeholder="0%"
                        value={handleRate}
                        onChange={handleChangeRate}
                        maxLength={5}
                      />
                    </div>
                    <div className="col-8">&nbsp;</div>
                    {rateErr ? (
                      <div className="col-12 d-flex justify-content-end errortext">
                        <span style={{ color: "red", fontSize: 12 }}>
                          Value should be between 2% - 13%
                        </span>
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <input
                      type="range"
                      className="w-100"
                      min="2"
                      max="13"
                      value={handleRate}
                      onChange={handleChangeRate}
                    />
                    <div className="d-flex justify-content-between startendval">
                      <span>2 %</span>
                      <span>13 %</span>
                    </div>
                  </div>
                </div>
                <div className="mb-4">
                  <div className="align-items-center row mb-3">
                    <div className="col-7 text-break">
                      <h4>
                        Period after which I want to know the value of SIP
                      </h4>
                    </div>
                    <div className="col-5 d-flex justify-content-end">
                      <input
                        type="text"
                        className="amtwidth"
                        placeholder="Enter Years"
                        value={handlePeriod}
                        onChange={handleChangePeriod}
                        maxLength={2}
                      />
                    </div>
                    <div className="col-8">&nbsp;</div>
                    {timeErr ? (
                      <div className="col-12 d-flex justify-content-end errortext">
                        <span style={{ color: "red", fontSize: 12 }}>
                          Value should be between 1 - 50
                        </span>
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <input
                      type="range"
                      className="w-100"
                      min="1"
                      max="50"
                      value={handlePeriod}
                      onChange={handleChangePeriod}
                    />
                    <div className="d-flex justify-content-between startendval">
                      <span>1 Years</span>
                      <span>50 Years</span>
                    </div>
                  </div>
                </div>
              </div>
              {smallPie && bigPie ? (
                <div className="currentandfuture">
                  <div className="row">
                  <div className="col-6">
                    <p className="text">Total Investment</p>
                    <p className="cfamount my-2">
                      ₹{" "}
                      {digitToRupeeNotation(
                        handleAmount * freqMapping * handlePeriod
                      )}
                    </p>
                  </div>
                  <div className="col-6">
                    <p className="text">Total SIP Value</p>
                    <p className="cfamount my-2">
                      ₹ {digitToRupeeNotation(totalSIP)}
                    </p>
                  </div>
                  <div className="col-12">
                    <div className="textbluediv">
                      <h4 className="text-center">Your earnings <span className="fw-bold">₹{" "}
                        {digitToRupeeNotation(
                          totalSIP - handleAmount * freqMapping * handlePeriod
                        )}</span>
                      </h4>
                    </div>
                  </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="col-md-6 buttondiv">
              <div className="ms-md-3">
                <div className="w-50 w-50 mx-auto">
                  <PieChart
                    data={[
                      {
                        title: "Total Investment",
                        value: smallPie,
                        color: "rgba(27, 75, 134)",
                      },
                      {
                        title: "Total SIP Value",
                        value: bigPie,
                        color: "rgba(214, 214, 214, 0.7)",
                      },
                    ]}
                    lineWidth={35}
                  />
                </div>
              </div>
              {smallPie && bigPie ? (
                <div className="row justify-content-center my-4">
                  <div className="col-md-9">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <div className="piecolor"></div>
                        <p>Total SIP Value</p>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="piecolor1"></div>
                        <p>Total Investment</p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              {/* {titledata && titledata.buttonText ? 
              <a href="#callbackform" className="callbackdiv">
                <div className="callback">{titledata && titledata.buttonText}</div>
              </a>
              :''} */}
            </div>
          </div>
        </div>
      </section>
  );
};

export default SipCalculator;
